import { useState, useEffect } from 'react';
import keys from 'lodash/keys';
import { callApiHooked } from '../callApiHooked';
import { API_BASE_URL } from '../../../App';

export const useGetRows = (id) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState();
  useEffect(() => {
    async function getData() {
      await callApiHooked(
        `${API_BASE_URL}/accounting-plans-v2/${id}`,
        'GET',
        null,
        null,
        (res) => {
          setLoading(false);
          const initialRows = keys(res).map((name, index) => ({ ...res[name], index }));
          setRows(initialRows);
        },
        (err) => {
          setError(err);
          setLoading(false);
        },
      );
    }
    getData();
  }, [id]);
  return { rows, error, loading, resetError: () => setError(null) };
};
